module.exports = __webpack_public_path__ + "media/src/images/icons/gray-close-circle-2c879dcc20a04caa72d377a2a4c5085d.svg";